import React from 'react';
import { prettifyXml } from '../Base/Common/CommonUIComponents';
import { Button, Modal, ModalBody, ModalHeader, ModalFooter } from 'reactstrap';

const LogsMessageModal = ({ isOpen, toggle, requestType, requestContent }) => {
    const downloadContent = () => {
        const bt = document.getElementById('downloadbtn');
        const name = `${requestType ? requestType.charAt(0).toUpperCase() + requestType.slice(1) : ''}`;

        if (requestContent.charAt(0) === '<' ) {
            bt.download = `${name}.xml`;
        }
        else if (requestContent.charAt(0) === '{' ) {
            bt.download = `${name}.json`;
        }
        else {
            bt.download = `${name}.txt`;
        }
    }

    const getContent = () => {
        if (requestContent?.charAt(0) === '<') {
            return prettifyXml(requestContent)
        }

        return requestContent
    }

    return (
        <Modal isOpen={isOpen} toggle={toggle} className="modal-xl">
            <ModalHeader toggle={toggle}>
                {requestType ? requestType : ''} Content
            </ModalHeader>
            <ModalBody>
                {requestContent && requestContent.length > 0 ?
                    <div className="text-right mb-2">
                        <a href={"data:text/plain;charset=utf-8, " + encodeURIComponent(getContent())} onClick={downloadContent} className="btn btn-host btn-sm text-white mr-2" id="downloadbtn" >
                            <i className="fa-solid fa-file-arrow-down "></i>
                        </a>
                    </div>
                : ''}

                <div className="overflow-auto" style={{ 'height': '70vh'}}>
                    <pre>
                        <code>
                            {getContent()}
                        </code>
                    </pre>
                </div>
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={toggle}>
                    Close
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default LogsMessageModal;